module.exports = __webpack_public_path__ + "img/FR12879.ab45dc4d.png";